import {Component, Inject} from '@angular/core';
import {MatSnackBar, MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import { SnackbarMessage } from '../../models';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    selector: 'app-snack-bar',
    templateUrl: 'receivingsnackbar.component.html',
    styleUrls: ['./receivingsnackbar.component.scss'],
    imports: [TranslateModule]
})
  export class ReceivingSnackbarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarMessage){}
  }